import { ADD_PACKAGE_PERMISSION, DELETE_PACKAGE_PERMISSION, GET_PACKAGE_PERMISSIONS, UPDATE_PACKAGE_PERMISSION, UPDATE_PACKAGE_PERMISSION_STATUS } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_PACKAGE_PERMISSIONS:
            return {...state, list: payload};

        case UPDATE_PACKAGE_PERMISSION:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case UPDATE_PACKAGE_PERMISSION_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case ADD_PACKAGE_PERMISSION:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_PACKAGE_PERMISSION:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
